import classNames from 'clsx';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';

import Translation from '@swf/components/Translation/Translation';
import Open from '@swf/core/assets/icons/open-leaderboard.svg';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';

import {
  TXTWCL_Completed_Races,
  TXTWCL_Show_less,
  TXTWCL_Show_more
} from './CompletedGrid.messages.json';
import styles from './CompletedGrid.scss';
import RaceBlock from './components/RaceBlock/RaceBlock';

export interface Props {
  path: string;
  races: CasinoRace[];
  showLeaderboard(racePath: string): () => void | Promise<void>;
  fetchCompleted(): void;
}

const CompletedGrid: React.FC<Props> = ({ path, races, fetchCompleted, showLeaderboard }) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (expanded) {
      fetchCompleted();
    }
  }, [expanded, fetchCompleted]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{TXTWCL_Completed_Races.defaultMessage}</h2>
      </div>
      <div className={styles.grid}>
        <RaceBlock path={path} races={races.slice(0, 4)} showLeaderboard={showLeaderboard} />
        {expanded && !isEmpty(races) && races.length > 4 && (
          <RaceBlock path={path} races={races.slice(4)} showLeaderboard={showLeaderboard} />
        )}
      </div>
      <div className={styles.open} onClick={() => setExpanded(!expanded)}>
        <div className={styles.title}>
          <Translation {...(expanded ? TXTWCL_Show_less : TXTWCL_Show_more)} />
          <Open className={classNames({ [styles.down]: !expanded })} />
        </div>
      </div>
    </div>
  );
};

export default CompletedGrid;
